// extracted by mini-css-extract-plugin
export default {"leftMargin":"companyElement_leftMargin__3TMXz"};